<template>
    <div class="text-center">
        <v-dialog persistent v-model="localVisible"  width="1200">
            <v-card class="not-margin pt-0 pr-0 pl-0">
                <v-toolbar dark color="primary">
                    <div class="text-center">
                        <v-icon> {{isView ? 'mdi-eye-outline' :'mdi-pencil'}}</v-icon>
                        {{ edit ? isView ? "Visualizar" :"Editar" : "Cadastrar" }} Solicitação de Formação
                    </div>
                </v-toolbar>
                <v-tabs v-model="tab" class="tabs" fixed-tabs background-color="transparent">
                    <v-tab :class="disabledClass" @click="setTab(0)">Plano de Trabalho</v-tab>
                    <v-tab :class="disabledClass" @click="setTab(1)">Programação</v-tab>
                    <v-tab :class="disabledClass" @click="setTab(2)">Orçamento</v-tab>
                </v-tabs>
                <v-tabs-items v-model="tab">
                    <v-tab-item>
                        <v-form ref="formPlanoTrabalho" v-if="tab === 0">
                            <AbaPlanoTrabalho 
                            ref="abaPlanoTrabalhoFrom"
                            :content="content.abaPlanoTrabalho"
                            @onClose="onClose"
                            @onSave="onSave"
                            @changeTab="changeTab"/>
                        </v-form>
                    </v-tab-item>
                    <v-tab-item>
                        <v-form ref="formAbaProgramacao" v-if="tab === 1">
                            <AbaProgramacao 
                            ref="abaProgramacaoFrom"
                            :content="content.abaProgramacao"
                            @onClose="onClose"
                            @onSave="onSave"
                            @changeTab="changeTab"/>
                        </v-form>
                    </v-tab-item>
                    <v-tab-item>
                        <v-form ref="formAbaOrcamento" v-if="tab === 2">
                            <AbaOrcamento 
                            ref="abaOrcamentoFrom"
                            :content="content.abaOrcamento"
                            @onClose="onClose"
                            @changeTab="changeTab"/>
                        </v-form>
                    </v-tab-item>
                </v-tabs-items>
            </v-card>
        </v-dialog>
    </div>
  </template>
  
  <script>
  import { Formacao } from '~/commons/classes/formacao';
  import AbaPlanoTrabalho from './AbaPlanoTrabalho.vue';
  import AbaProgramacao from './AbaProgramacao.vue';
  import AbaOrcamento from './AbaOrcamento.vue';
  import { DialogPropsFormacao } from '~/commons/classes/dialog-props-formacao';
  import { globalStore } from '~/mixins/global-formacao.mixin';
  import { AUTH_NAMESPACE, USER, LOGIN } from 'store/modules/auth';
  export default {
    name: "Formacao",
    props: new DialogPropsFormacao(Formacao),
    components: { AbaPlanoTrabalho, AbaProgramacao, AbaOrcamento },
    data() {
        return {
            tab: 0,
            localVisible: this.visible,
        };
    },
    watch: {
        visible(newValue) {
            this.localVisible = newValue;

            if (newValue) {
                this.tab = 0;
            }
        }
    },
    computed: {
        disabledClass() {
            const bloqueioDeAbas =  globalStore.isViewMode;
            return bloqueioDeAbas ? '' : 'disabled-tab';
        },
        isView() {
            return globalStore.isViewMode;
        },
        user() {
            return this.$store.getters[`${AUTH_NAMESPACE}/${USER}/${LOGIN}`];
        },
    },
    methods: {
        setTab(index) {
            this.tab = index;
        },
        changeTab(index) {
            this.tab = index;
        },
        onClose() {
            this.tab = 0;
            this.localVisible = false;
            this.$emit('onClose');
        },
        onSave() {
            this.$emit('onSave');
        },
    },
  };
</script>
<style scoped>
  .tabs .v-tab {
    cursor: pointer;
  }
  .disabled-tab {
    pointer-events: none;
    color: #ccc;
  }
</style>